module.exports = __webpack_public_path__ + "static/media/happy-parent-banner.313a34a2.jpg";